import React from "react";
import { DateHelper } from "shared/helpers/DateHelper";

export default function ActItemSubscript({ details, dateHelper }) {
  if (details.isLeading) {
    return (
      <div className="Act-item-subscript subscript-txtstyl">
        {dateHelper.getDayNameLong(DateHelper.parseDate(details.day))}
      </div>
    );
  } else {
    return null;
  }
}
